<template>
	<div>
		<div v-if="isval" class="msg_box">
			<div class="box_aqa">
				<h3>很抱歉，您查看的活动找不到了！</h3>
				<div class="aqa_zi">
					<p>您可以:</p>
					<div>1.检查刚才的输入</div>
					<div>2.去其他地方逛逛：<span class="lan" @click="xin.goUrl('/index')">首页</span></div>
				</div>
			</div>
		</div>
		<div v-else class="msg_box">
			<div class="arrow_box clearfloat">
				<span class="arrow_ywz">您的位置：</span>
				<div class="arrow">
					<span class="to" @click="xin.goUrl('/index')">首页</span>
					<span class="el-icon-arrow-right"></span>
					<span class="to" @click="xin.goUrl('/activity')">活动专区</span>
					<span class="el-icon-arrow-right"></span>
					<span class="topc">活动详情</span>
				</div>
			</div>
			<div class="min_he400" v-loading="loading">
				<p class="act_title">{{activityInfo.title}}</p>
				<p class="act_title2">{{activityInfo.subtitle}}</p>
				<div v-html="activityInfo.content"></div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return {
				loading:true,
				isval:false,
				activityInfo:{}
			}
		},
		watch:{
			$route(to,from){
				this.Postactivityinfo(to.query.aid);
			}
		},
		created(){
			this.Postactivityinfo(this.$route.query.aid);
		},
		methods:{
			async Postactivityinfo(activity_id){
				if(!activity_id){
					this.isval = true;
					return;
				}
				this.loading = true;
				let {data} = await this.api.Postactivityinfo({activity_id});
				if(data)
					this.activityInfo = data;
				else this.isval = true;
				this.loading = false;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.act_title{
		text-align: center;
		font-size: 18px;
		font-weight: 600;
	}
	.act_title2{
		text-align: center;
		color: #8F8F8F;
	}
</style>
